import { render, staticRenderFns } from "./CarRentalCategories.vue?vue&type=template&id=48233c07&scoped=true&"
import script from "./CarRentalCategories.vue?vue&type=script&lang=js&"
export * from "./CarRentalCategories.vue?vue&type=script&lang=js&"
import style0 from "./CarRentalCategories.vue?vue&type=style&index=0&id=48233c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48233c07",
  null
  
)

export default component.exports